import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';

class Header extends React.Component {

    genBackButton() {

        if (this.props.clickBack)
        {
            return (
                <div class="cancel" onClick={this.props.clickBack}>
                    {"<"} back
                </div>
            );
        } else if (!window.location.pathname.startsWith("/crazy")) {

            return (
                <div class="moreIO" onClick={this.clickMoreIO}>
                    More IO Games
                </div>
            );
        } 
    }

    clickMoreIO() {
        if (window.location.pathname.startsWith("/insanegames"))
            window.open("https://insanegames.io/", "_blank");
        else
            window.open("https://iogames.space/", "_blank");
    }

    clickMouse() {
        window.open("https://traitors.sh/", "_blank")
    }

    clickPart() {
        window.open("https://traitors.sh/resources/partners.html", "_blank")
    }

    genMouseZones() {

        /*
            const style = {
                position: "absolute",
                top: "200px",
                right: "5px",
                visibility: "visible",
                zIndex: 10,
                border: "1px solid red",
            }
            return (
                <iframe style={style} id="IOG_CP" scrolling="no" frameborder="0" width="220" height="125" src="http://viral.iogames.space"></iframe>
            );
        */

        if (this.props.shouldShowRedirect) {
            return (
                <div class="subTitle2" onClick={this.clickMouse}>
                    Play on Traitors.sh <br/>
                    for better <br/>
                    mouse zones >>> <br/>
                </div>
            );
        }
    }

    genPowerupList() {
        return (
            <div class="subTitle3" onClick={this.clickPowerupList}>
                Powerup List >>
            </div>
        );
    }

    clickPowerupList() {
        window.open("https://traitors.sh/resources/list.html", "_blank");
    }

    genRankedWarning() {
        if (this.props.firstTimeRanked && this.props.ranked)
            return (
                <div class="rankedWarn">
                    After you finish your first ranked game, you will be added<br/>to our ranked leaderboards
                </div>
            );//'
    }

	render() {

        return (
            <div class={this.props.ranked ? "blue" : "red"}>
                <div class="center">
                    <h1>
                        { this.props.name }
                    </h1>
                </div>
                <div class={this.props.ranked ? "subTitleBlue" : "subTitle"}>
                    // Hide in the crowd
                </div>

                { this.genRankedWarning() }
                { this.genMouseZones() }

                <div class="subTitle4" onClick={this.clickPart}>
                    Partner Links >>
                </div>

                { this.genBackButton() }

                { this.genPowerupList() }
                
                <div class="solid"></div>
            </div>
        );
    }
}

Header.propTypes = {

  name: PropTypes.string,
  clickBack: PropTypes.func,
  shouldShowRedirect: PropTypes.bool,
  ranked: PropTypes.bool,
  firstTimeRanked: PropTypes.bool,
};

Header.defaultProps = {
  name: 'Traitors.sh'
};

export default Header;